import { isTouchDevice } from '../../../utils/device';

export const isTapEvent = (e: UIEvent) => {
  return e.type === 'click' && isTouchDevice;
};
